import {
  benefitListResponse,
  createBenefitPayload,
  updateBenefitPayload,
} from 'interfaces/Benefit';
import api from 'services';

const path = '/benefit';

// Listar benefícios
export const getBenefitList = async (): Promise<benefitListResponse> => {
  const response = await api.get<benefitListResponse>(`${path}/list`);
  return response.data;
};

// Buscar benefício por ID
export const getBenefitById = async (id: number): Promise<benefitListResponse> => {
  const response = await api.get<benefitListResponse>(`${path}/${id}`);
  return response.data;
};

// Criar benefício
export const createBenefit = async (payload: createBenefitPayload): Promise<benefitListResponse> => {
  const response = await api.post<benefitListResponse>(`${path}/`, payload);
  return response.data;
};

// Atualizar benefício
export const updateBenefit = async (payload: updateBenefitPayload): Promise<benefitListResponse> => {
  const { id, ...data } = payload;
  const response = await api.put<benefitListResponse>(`${path}/${id}`, data);
  return response.data;
};

// Deletar benefício
export const deleteBenefit = async (id: number): Promise<void> => {
  await api.delete(`${path}/${id}`);
};
